
import { React, useState } from 'react';
import { signOut } from "../../utils/signOut";
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import Hamburger from 'hamburger-react';
import "../../styles/Admin-ui/Admin-SideBar.css";
// Last, so its small-screen rules win: Patient-Homepage.css hides .Tab-section
// on phones, which hid this menu on every admin screen.
import "../../styles/Admin-ui/Admin-Mobile.css";
import { FaHospitalUser, FaUsers, FaBan, FaNotesMedical, FaChartLine } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { COOKIE_KEYS } from "../../App";
import Cookies from "js-cookie";
import { FaSignOutAlt } from 'react-icons/fa';
import { ImFileText } from "react-icons/im";

import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
function AdminSideBar(props) {
    const [collapse, setCollapse] = useState(true);
    const navigate = useNavigate();
    // Analytics is the owner's screen, not the assistant's: every endpoint behind
    // it answers 403 to an assistant, so offering the link would only lead to an
    // error page. The route enforces this too — this just stops it being offered.
    const isAdmin = Cookies.get(COOKIE_KEYS.userType) === 'ADMIN';

    // The one shared sign-out: ends the session on the server too. See utils/signOut.
    const handleLogout = () => signOut();


    return (
        <div className='admin-sidebar'>
            <div className='Tab-section'>
                <Sidebar backgroundColor="#9CB189" className='Side-bar' collapsed={collapse}>

                    <Menu menuItemStyles={{
                        button: ({ active }) => {
                            // only apply styles on first level elements of the tree
                            if (active == true)
                                return {
                                    backgroundColor: active ? '#808080' : undefined,
                                };

                        },
                    }}>
                        <div className='Hamburger'>
                            <Hamburger toggled={collapse} toggle={setCollapse} size={40} />
                        </div>
                        {isAdmin && (
                            <Tooltip title={<p style={{ margin: "2px", fontSize: "12px" }}>Analytics</p>} placement="right-start" enterDelay={100} leaveDelay={100} followCursor TransitionComponent={Zoom} disableFocusListener disableTouchListener>
                                <MenuItem onClick={() => navigate("/admin-analytics")} icon={<FaChartLine size={40} />} active={props.data === 'admin-analytics'} className="Menu-item" >Analytics</MenuItem>
                            </Tooltip>
                        )}
                        <Tooltip title={<p style={{ margin: "2px", fontSize: "12px" }}>Doctors</p>} placement="right-start" enterDelay={100} leaveDelay={100} followCursor TransitionComponent={Zoom} disableFocusListener disableTouchListener>
                            <MenuItem onClick={() => navigate("/admin-doctors")} icon={<FaHospitalUser size={40} />} active={props.data === 'admin-doctors'} className="Menu-item" >Doctors</MenuItem>
                        </Tooltip>
                        <Tooltip title={<p style={{ margin: "2px", fontSize: "12px" }}>Patients</p>} placement="right-start" enterDelay={100} leaveDelay={100} followCursor TransitionComponent={Zoom} disableFocusListener disableTouchListener>
                            <MenuItem onClick={() => navigate("/admin-patients")} icon={<FaUsers size={40} />} active={props.data === 'admin-patients'} className="Menu-item" > Patients</MenuItem>
                        </Tooltip>

                        <Tooltip title={<p style={{ margin: "2px", fontSize: "12px" }}>Denied Doctors</p>} placement="right-start" enterDelay={100} leaveDelay={100} followCursor TransitionComponent={Zoom} disableFocusListener disableTouchListener>
                            <MenuItem onClick={() => navigate("/admin-denied-doctors")} icon={<FaBan size={40} />} active={props.data === 'admin-denied-doctors'} className="Menu-item" >Denied Doctors</MenuItem>
                        </Tooltip>

                        <Tooltip title={<p style={{ margin: "2px", fontSize: "12px" }}>Manage-Prescriptions</p>} placement="right-start" enterDelay={100} leaveDelay={100} followCursor TransitionComponent={Zoom} disableFocusListener disableTouchListener>
                            <MenuItem onClick={() => navigate("/manage-approved-medicine")} icon={<FaNotesMedical size={40} />} active={props.data === 'manage-approved-medicine'} className="Menu-item" > Manage-Prescriptions</MenuItem>
                        </Tooltip>

                        <Tooltip title={<p style={{ margin: "2px", fontSize: "12px" }}>Assist</p>} placement="right-start" enterDelay={100} leaveDelay={100} followCursor TransitionComponent={Zoom} disableFocusListener disableTouchListener>
                            <MenuItem onClick={() => navigate("/admin-assistants")} icon={<FaHospitalUser size={40} />} active={props.data === 'admin-assistants'} className="Menu-item" >Assist</MenuItem>
                        </Tooltip>

                        <Tooltip title={<p style={{ margin: "2px", fontSize: "12px" }}>Note-Templates</p>} placement="right-start" enterDelay={100} leaveDelay={100} followCursor TransitionComponent={Zoom} disableFocusListener disableTouchListener>
                            <MenuItem onClick={() => navigate("/admin-note-template")} icon={<ImFileText size={40} />} active={props.data === 'admin-note-template'} className="Menu-item" >NoteTemplate</MenuItem>
                        </Tooltip>

                        <Tooltip title={<p style={{ margin: "2px", fontSize: "12px" }}>Logout</p>} placement="right-start" enterDelay={100} leaveDelay={100} followCursor TransitionComponent={Zoom} disableFocusListener disableTouchListener>
                            <MenuItem onClick={handleLogout} className="Menu-item" icon={<FaSignOutAlt size={40} color='white' />} >Logout</MenuItem>
                        </Tooltip>

                        {/* <MenuItem onClick={() => navigate("/admin-profile")} icon={<FaPowerOff size={40} />} active={props.data === 'admin-profile'} className="Menu-item" > Profile</MenuItem> */}
                    </Menu>
                </Sidebar>
            </div>

        </div>
    );
}

export default AdminSideBar;

